<template>
  <div class="buy-container">
    <!-- header -->
    <div class="buy-header">
      <div class="buy-header-box">
        <img :src="data.promotionimg" alt="">
        <div class="right">
          <h3>
            <span>{{data.bigCourseName}}</span>
            <!-- <span>个人战略 - </span>商业价值重塑 -->
          </h3>
          <small>开课时间：{{data.coursetime}}</small>
        </div>
      </div>
    </div>
    <!-- content -->
    <div class="buy-content">
      <h3>课前任务<span>{{data.count}}/3</span></h3>
      <!-- task -->
      <div v-for="(item,index) in buy_task_list" :key="index" :class="['buy-task',index==0?'on':'']">
        <p>{{item.content}}</p>
        <!-- 判断是否是添加班主任微信 -->
        <a @click="toPageHandle(item.path)" 
          v-if="item.isComplete && 
            (item.path === '/project_details' || 
            item.path==='/mentor_wechat' || 
            item.path==='/list' )" 
          class="successf-wechart" >
            {{item.link_title}}
        </a>
        <a @click="toPageHandle(item.path)" 
          v-else-if="!item.isComplete" 
          class="successf" >{{item.link_title}}</a>
        <a v-else class="err" >{{item.link_title}}</a>
        
      </div>
      <!-- 注 -->
      <p class="note">*完成以上任务，等待{{data.coursetime.match(/(\S*)日/)[0]}}的课程和面基吧~</p>
    </div>
    <!-- 判断是否关注没 -->
    <van-popup :close-on-click-overlay="false" v-model="assistant_show" class="pop_assistant">
      <div class="pop_assistant_box">
        <h3>{{userdetail.nickname}}你好！您已成功报名<br/>{{data.coursename}}，<br/>为了不和组织失联，<br/>请关注下方【人才加速器公众号】</h3>
        <img src="@a/carrer.png" />
        <h4>（请长按识别或扫描上方二维码关注）</h4>
      </div>
    </van-popup>
    <!-- 是否填写入学资料 -->
    <van-popup class="pub_alert" v-model="fill_information">
      <div class="confirm_box">
        <h2>您的课前任务“填写资料”和“添加班主任”还未完成</h2>
        <h3>完成以上课前任务在开始上课吧！</h3>
        <div class="btn_group">
          <a class="cancel" href="javascript:;" @click="fill_information=false">OK</a>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { shareCon } from "@/utils/wxconfig"
export default {
  data() {
      return {
        cid: "",
        userdetail: {},
        assistant_show: false,
        pay: "",
        addwechat: {},
        buy_task_list:[],
        fill_information:false
      }
    },
    props:['data'],
    methods: {
      toPageHandle(path_){
        if(path_==='/list' && !this.data.datastate){
          this.fill_information = true;
        }else{
          let obj ={
            cid:this.$route.query.cid
          };
          if(path_==='/project_details'){
            obj['cpid'] = this.data.cpid;
          }
          this.$router.push({
            path:path_,
            query:obj
          });
        }
      },
      pullData() {
        // 加载等待Loading
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        this.buy_task_list = [
          {
            content:'系统会按照工作职级和年限为你自动匹配学习小组，请尽快准确填写个人信息哦！',
            link_title:'填写资料',
            path:'/information',
            isComplete:this.data.datastate
          },
          {
            content:'报名后请第一时间添加班主任微信，领取重要学习信息。',
            link_title:'添加班主任',
            path:'/mentor_wechat',
            isComplete:this.data.qrcode
          },
          // 判断是否完成资料填写或者添加导师微信
          {
            content:this.data.begintime==0?'完成以上课前任务再开始上课吧！':'为了更好的学习效果，请在开课前完成热身学习。',
            link_title:this.data.begintime==0?'去上课':'热身思考',
            path:this.data.begintime==0?'/list':'/project_details',
            isComplete:this.data.p0done
          }
        ];
        
        this.addwechat = this.data.addwechat;
        this.userdetail = this.data.userdetail;
        // if(!this.data.subscribe) {
        //   this.assistant_show = true;
        // }
        this.$toast.clear();

      }
    },
    created() {
      this.pullData();
      shareCon("course",this);
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.buy-container{
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 100%;
  left: 0;
  top:0;
  right: 0;
  bottom: 0;
}
.buy-header{
  display: flex;
  padding: 45px 30px;
  .buy-header-box{
    overflow: hidden;
    position: relative;
    width: 100%;
    display: flex;
    padding: 20px 30px;
    align-items: center;
    border-radius:12px;
    background: url(../../../assets/buy-suf-head.png) center no-repeat;
    background-size: 100% 100%;
    img{
      width: 220px;
      height: 126px;
      background-color: #D0C5A6;
    }
    .right{
      margin-left: 20px;
      color: #fff;
      flex: 1;
      height: 100%;
      h3{
        font-size: 28px;
        line-height: 1;
        margin-bottom: 20px;
        span{
          font-size: 34px;
        }
      }
      small{
        line-height: 1;
        font-size: 26px;
      }
    }
  }
}
.buy-content{
  padding: 50px 30px 30px 30px;
  border-top-left-radius: 48px;
  border-top-right-radius: 48px;
  background-color: #fff;
  flex: auto;
  .note{
    font-size: 24px;
    color: #999999;
    margin-top: 22px;
  }
  h3{
    font-size: 28px;
    color: #333333;
    span{
      margin-left: 20px;
      color: #EB5032;
    }
  }
  .buy-task{
    margin-top: 48px;
    display: flex;
    align-items: center;
    color: #333333;
    font-size: 26px;
    border-bottom:2px solid rgba(204,204,204,1);
    padding-bottom: 30px;
    p{
      width: 448px;
      line-height: 39px;
    }
    a{
      margin-left: auto;
      display: block;
      width:150px;
      height:54px;
      line-height: 54px;
      text-align: center;
      border-radius:27px;
    }
    a.successf-wechart{
      background: transparent;
      color: #EB5032;
      border:1px solid #EB5032;
    }
    a.successf{
      background:#EB5032;
      color: #fff;
    }
    a.err{
      background: transparent;
      color: #ccc;
      border:1px solid #ccc;
    }
  }
  .buy-task.on{
    margin-top: 50px;
  }
}

/*弹窗带二维码的*/
.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    border-radius: 8px;
    background-color: #fff;
    padding: 35px 55px 40px;
    img {
      width: 434px;
      height: 434px;
      margin-top: 18px;
    }
    h3 {
      font-size: 34px;
      color: #333333;
      line-height: 50px;
      span.on {
        color: #EB5032;
      }
    }
    h4 {
      margin-top: 18px;
      font-size: 24px;
      color: #666;
      line-height: 30px;
    }
  }
}
.confirm_box h2 {
  padding: 25px 20px;
  padding-bottom: 10px
}

.confirm_box h3 {
  margin: 10px 0;
  color: #999;
  font-size: 26px;
  text-align: center;
}

.confirm_box .btn_group a.cancel {
  width: 100%;
  color: #EB5032
}
</style>